import { render } from "./MsLogin.vue?vue&type=template&id=9cf923fc"
import script from "./MsLogin.vue?vue&type=script&lang=js"
export * from "./MsLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__